import { FORGET_CART } from '~/redux/actions/types'

export const forgetCart = () => {
  return {
    type: FORGET_CART
  }
}
